var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rent-kebab-view',{attrs:{"items":_vm.filteredItems,"parent-event":_vm.parentEvent,"params-data":_vm.params.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }